module.exports = __webpack_public_path__ + "static/media/alerts_icon.4accbcb4.png";